module.exports = __webpack_public_path__ + "static/img/callIn.1843e0a0.png";